
/* 
  param.b
  param.c
  param.d

  SPM的a位定义：
  a位表示站点。取miio.shop_source表的source字段表示各站点(m站、小程序没有添加，需要在该表里面新加，m站：M；小程序：WEIXINLITE)，但因为app需要区分os，所以米家APP，有品APP，路由器APP需要以下划线加上os的标识，A表示android，I表示ios，以米家APP为例，其a位标识为SmartHome_A（米家android），SmartHome_I（米家ios）

  SPM的b位定义：
  b位表示页面。从搭建系统（后台）取page_id；

  SPM的c位：
  c位表示模块（楼层），从搭建系统（后台）取area；

  SPM的d位：
  d位表示模块里的坑位的位置，如1,2,3...，这个值需要从前端计算得出, head代表-1；

*/
declare global {
  export interface Window {
    _MiHomeStore: any;
    __wxjs_environment: string;

    wx: any;
    tt: any;
    system: any;

  }

  export interface Document {
    webkitHidden: any;
  }
  export interface Object {
    assign: any;
  }
  interface Utm {
    mtm?: string
  }
  interface Spm {
    a?: string,
    b: string,
    c?: string,
    d?: string,
    url?: string,
    scm?: string,
    spmref?: string
  }
  interface EventProps {
    spm?: Spm | string,
    spmref?: string,
    pageId?: string | number,
    page_name?: string,
    pageName?: string,
    page?: string,
    cm_id?: string | number,
    scm?: string,
    scmref?: string,
    scmref_step?: string | number,
    xiaomi_id?: string,
    uri?: string,
    uriref?: string,
    utm?: Utm,
    params?: object,
    event_id?: number,
    session?: string
  }
  interface StatProps {
    spm: Spm | string,
    pageId?: string | number,
    page_name: string,
    page: string,
    iid?: string,
    area?: string,
    spmref?: string,
    cm_id?: string | number,
    scm?: string,
    scmref?: string,
    scmref_step?: string | number,
    b?: string,
    uri?: string,
    uriref?: string,
    xiaomi_id?: string,
    utm?: Utm,
    params?: object,
    event_id?: number,
    session?: string,
    eventName?: string
  }
}
class Base {
  pageName: string;
  scm: string;
  b: string;
  a: string;
  random: number;
  isAgree: string;
  event_id: number;
  session: string;
  platform: 'RN' | 'WEB' | ''
  constructor() {
    // 传入方法
    this.pageName = "";
    this.scm = "";
    this.b = "";
    this.a = ''
    this.random = 0;
    this.event_id = 0;
    this.session = 'auto_' + new Date().getTime();
    this.platform = '';
    setInterval(() => {
      this.event_id = 0;
      this.session = 'auto_' + new Date().getTime();
    }, 1000 * 60 * 30);
  }
  hasEvent(eventName: string): number {
    const eventList = {
      'view': 1,
      'touch': 1,
      'info': 1,
      'visible': 1,
      'viewend': 1,
    }
    return eventList[eventName] || 0
  }
  /**
   *
   * @param {string} pageName
   * @param {string} url
   * @param {*} pageId
   * @param {*} iid
   * @param {object} params - spm:{b,c,d}
   */
  view(pageName: string, url: string, pageId?: string | number, iid?: string, params?: EventProps) {
    // try {
    params = params || {};
    this.pageName = pageName.toLowerCase() !== 'web' ? pageName : this.pageName;
    this.scm = params.scm || "";
    // 缓存b，同一页面的其他事件可以免传
    if (typeof (params.spm) !== 'string') {
      this.b = (params.spm && params.spm.b) || "";
      this.a = (params.spm && params.spm.a) || this.a
    }
    let spmData = this._getSpm(params);
    var props = {
      spm: spmData.spm,
      spmref: this._isEmpty(params.spmref),
      scm: this._isEmpty(params.scm),
      scmref: this._isEmpty(params.scmref),
      scmref_step: parseInt(this._isEmpty(params.scmref_step)) || 0,
      page: this._isEmpty(pageName),
      page_name: this._isEmpty(pageName),
      pageId: this._isEmpty(pageId),
      iid: this._isEmpty(iid),
      uri: url,
      b: spmData.b,
      xiaomi_id: this._isEmpty(params.xiaomi_id),
      uriref: this._isEmpty(params.uriref),
      utm: params.utm || {},
      params: params.params || {},
      event_id: this.event_id++,
      session: this.session
    };
    return this.stat("VIEW", pageName, url, this._isEmpty(iid), props);
    // } catch (error) {
    //   console.log("sdk报错：参数有误");
    // }
  }
  stat(arg0: string, arg1: string, arg2: string, arg3: string, arg4: StatProps) {

  }
  /**
   *
   * @param {string} area
   * @param {*} iid
   * @param {object} params - spm:{b,c,d}
   */
  touch(area: string, iid?: string, params?: EventProps) {
    params = params || {};
    let pageName = this.pageName
    // webview通过RN上报的时候，传pageName，就替换，正常就不替换
    if (params.page_name || params.pageName || params.page) {
      pageName = params.page_name || params.pageName || params.page
    }
    try {
      let spmData = this._getSpm(params, area, "touch");
      var props = {
        spm: spmData.spm ? spmData.spm : "",
        spmref: this._isEmpty(params.spmref),
        page: pageName,
        page_name: this._isEmpty(pageName),
        pageId: this._isEmpty(params.pageId),
        iid: this._isEmpty(iid),
        cm_id: this._isEmpty(params.cm_id),
        scm: this._isEmpty(params.scm),
        scmref: this._isEmpty(params.scmref),
        scmref_step: parseInt(this._isEmpty(params.scmref_step)) || 0,
        b: spmData.b,
        xiaomi_id: this._isEmpty(params.xiaomi_id),
        uri: this._isEmpty(params.uri),
        uriref: this._isEmpty(params.uriref),
        utm: params.utm || {},
        params: params.params || {},
        event_id: this.event_id++,
        session: this.session
      };
      if (!params.cm_id) {
        delete props.cm_id
      }
      return this.stat(
        "TOUCH",
        this._isEmpty(area),
        this._isEmpty(iid),
        this._isEmpty(iid),
        props
      );
    } catch (error) {
      console.log("sdk报错：参数有误");
    }
  }
  /**
   *
   * @param {string} area
   * @param {*} iid
   * @param {object} params - spm:{b,c,d}
   */
  custom(eventName: string, area: string, iid?: string, params?: EventProps) {
    params = params || {};
    let pageName = this.pageName
    // webview通过RN上报的时候，传pageName，就替换，正常就不替换
    if (params.page_name || params.pageName || params.page) {
      pageName = params.page_name || params.pageName || params.page
    }
    try {
      let spmData = this._getSpm(params, area, "custom");
      var props = {
        spm: spmData.spm ? spmData.spm : "",
        spmref: this._isEmpty(params.spmref),
        page: pageName,
        page_name: this._isEmpty(pageName),
        pageId: this._isEmpty(params.pageId),
        iid: this._isEmpty(iid),
        cm_id: this._isEmpty(params.cm_id),
        scm: this._isEmpty(params.scm),
        scmref: this._isEmpty(params.scmref),
        scmref_step: parseInt(this._isEmpty(params.scmref_step)) || 0,
        b: spmData.b,
        xiaomi_id: this._isEmpty(params.xiaomi_id),
        uri: this._isEmpty(params.uri),
        uriref: this._isEmpty(params.uriref),
        utm: params.utm || {},
        params: params.params || {},
        event_id: this.event_id++,
        session: this.session,
        eventName
      };
      if (!params.cm_id) {
        delete props.cm_id
      }
      return this.stat(
        "CUSTOM",
        this._isEmpty(area),
        this._isEmpty(iid),
        this._isEmpty(iid),
        props
      );
    } catch (error) {
      console.log("sdk报错：参数有误");
    }
  }
  /**
   *
   * @param {string} area
   * @param {*} iid
   * @param {object} params - spm:{b,c,d}
   */
  info(area: string, iid?: string, params?: EventProps) {
    params = params || {};
    let pageName = this.pageName
    // webview通过RN上报的时候，传pageName，就替换，正常就不替换
    if (params.page_name || params.pageName || params.page) {
      pageName = params.page_name || params.pageName || params.page
    }
    try {
      let spmData = this._getSpm(params, area, "info");
      var props = {
        spm: spmData.spm ? spmData.spm : "",
        spmref: this._isEmpty(params.spmref),
        page: pageName,
        page_name: this._isEmpty(pageName),
        pageId: this._isEmpty(params.pageId),
        iid: this._isEmpty(iid),
        scm: this._isEmpty(params.scm),
        scmref: this._isEmpty(params.scmref),
        scmref_step: parseInt(this._isEmpty(params.scmref_step)) || 0,
        b: spmData.b,
        xiaomi_id: this._isEmpty(params.xiaomi_id),
        uri: this._isEmpty(params.uri),
        uriref: this._isEmpty(params.uriref),
        utm: params.utm || {},
        params: params.params || {},
        event_id: this.event_id++,
        session: this.session
      };
      return this.stat(
        "INFO",
        this._isEmpty(area),
        this._isEmpty(iid),
        this._isEmpty(iid),
        props
      );
    } catch (error) {
      console.log("sdk报错：参数有误");
    }
  }
  /**
   *
   * @param {string} area
   * @param {*} iid
   * @param {object} params - spm:{b,c,d}
   */
  visible(area: string, iid?: string, params?: EventProps) {
    params = params || {};
    let pageName = this.pageName
    // webview通过RN上报的时候，传pageName，就替换，正常就不替换
    if (params.page_name || params.pageName || params.page) {
      pageName = params.page_name || params.pageName || params.page
    }
    try {
      let spmData = this._getSpm(params, area, "visible");
      var props = {
        area: this._isEmpty(area),
        spm: spmData.spm,
        spmref: this._isEmpty(params.spmref),
        page_name: this._isEmpty(pageName),
        page: pageName,
        iid: this._isEmpty(iid),
        cm_id: this._isEmpty(params.cm_id),
        scm: this._isEmpty(params.scm),
        scmref: this._isEmpty(params.scmref),
        scmref_step: parseInt(this._isEmpty(params.scmref_step)) || 0,
        b: spmData.b,
        xiaomi_id: this._isEmpty(params.xiaomi_id),
        uri: this._isEmpty(params.uri),
        uriref: this._isEmpty(params.uriref),
        utm: params.utm || {},
        params: params.params || {},
        event_id: this.event_id++,
        session: this.session
      };
      if (!params.cm_id) {
        delete props.cm_id
      }
      return this.stat(
        "VISIBLE",
        this._isEmpty(area),
        this._isEmpty(iid),
        this._isEmpty(iid),
        props
      );
    } catch (error) {
      console.log("sdk报错：参数有误");
    }
  }
  viewend(iid?: string, params?: EventProps) {
    params = params || {};
    let pageName = this.pageName
    // webview通过RN上报的时候，传pageName，就替换，正常就不替换
    if (params.page_name || params.pageName || params.page) {
      pageName = params.page_name || params.pageName || params.page
    }
    let spmData = this._getSpm(params);
    var props = {
      spm: spmData.spm,
      spmref: this._isEmpty(params.spmref),
      iid: this._isEmpty(iid),
      page_name: this._isEmpty(pageName),
      page: pageName,
      scm: this._isEmpty(params.scm),
      scmref: this._isEmpty(params.scmref),
      scmref_step: parseInt(this._isEmpty(params.scmref_step)) || 0,
      b: spmData.b,
      xiaomi_id: this._isEmpty(params.xiaomi_id),
      uri: this._isEmpty(params.uri),
      uriref: this._isEmpty(params.uriref),
      params: params.params || {},
      event_id: this.event_id++,
      session: this.session
    };
    return this.stat(
      "VIEWEND",
      '',
      this._isEmpty(iid),
      this._isEmpty(iid),
      props
    );
  }
  getScm() {
    return this.scm || "";
  }
  // 内部方法，抽象spm用
  private _getSpm(params?: EventProps, area?: string, eventName?: string): { spm: string, b: string } {

    let pageName = this.pageName;
    // if (eventName === "touch" || eventName === "visible") {
    //   pageName = `$${pageName}$`;
    // }

    let paramsSpm: { b?: string } = {};
    if (typeof (params.spm) !== 'string') {
      paramsSpm = { ...params.spm } || {};
    }
    if (!paramsSpm.b && paramsSpm.b != '0') {
      // 这里先取缓存的b
      if (this.b) {
        let b = `${this.b}`;
        // if (b.charAt(0) !== "$") {
        //   b = `$${b}$`;
        // }
        paramsSpm.b = `${b}`;
      } else {
        paramsSpm.b = `${pageName}`;
      }
    }
    let defaultSpm = {
      b: pageName,
      c: area || "",
      d: ""
    };
    // 兼容RN直接传spm的情况
    if (params.spm && typeof (params.spm) === 'string') {
      // 这里纯粹是RN喜欢先调用getSpm方法，导致随机数不一致 ，所以这里记录一下
      if (eventName === 'touch') {
        let spmArr = String(params.spm).split('.')
        if (spmArr && spmArr.length) {
          let random = spmArr[spmArr.length - 1]
          if (random.length > 0) {
            this.random = parseInt(random)
          }
        }
      } else {
        this.random = 0
      }
      return {
        spm: params.spm,
        b: { ...defaultSpm, ...paramsSpm }.b
      };
    }
    // 返回外部spm的值
    return {
      spm: this.getSpm({ ...defaultSpm, ...paramsSpm }, eventName),
      b: { ...defaultSpm, ...paramsSpm }.b
    }
  }
  /**
   * 获取该页面的spm 或者 带有spmref和scm的url
   * @param {Object} param
   */
  getSpm(param: Spm, eventName?: string) {
    let random = Math.floor(Math.random() * Math.pow(10, 8));
    if (eventName === "touch") {
      this.random = random;
    } else if (!eventName && this.random !== 0) {
      random = this.random;
    }
    let spmref = "";
    if (param && param.b) {
      let a = param.a || this.a || "H5";
      spmref = `${a}.${param.b}.${param.c || 0}.${param.d || 0}.${random}`;
    } else {
      return "";
    }
    return spmref;
  }

  _isEmpty(str: any) {
    if (str && str !== undefined && str !== null) {
      return String(str);
    } else if (str === 0) {
      return "0";
    } else {
      return "";
    }
  }
}

export default Base;
